import { Col, Row } from 'react-bootstrap';
import styled from 'styled-components';
import { Link } from 'v3/components/';

import theme from 'v3/theme';

export const ModalContent = styled.div`
  color: ${theme.colors.dark};
`;

export const LoadingWrapper = styled.div`
  padding: 32px 0;
`;

export const SectionHeader = styled(Row)`
  padding-bottom: 16px;
  margin-bottom: 24px;
  border-bottom: 1px solid ${theme.colors.secondary};
`;

export const SectionTitle = styled.div`
  padding-bottom: 16px;
  margin: 28px 0 20px;
  border-bottom: 1px solid ${theme.colors.secondary};
`;

export const SectionDivider = styled.div`
  border-bottom: 1px solid ${theme.colors.secondary};
  margin-top: 20px;
`;

export const HeaderColumns = styled(Row)`
  margin: 0;
`;

export const HeaderCell = styled(Col)`
  flex: 1;
  padding: 0 24px;
`;

export const WaitingHeader = styled(Col)`
  width: 72px;
  min-width: 72px;
`;

export const Check = styled.div`
  position: relative;
  z-index: 1;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  line-height: 1;
  text-align: center;
  background-color: ${theme.colors.medium_gray};
  display: flex;
  align-items: center;
  justify-content: center;
  > svg {
    display: none;
  }
`;

export const TimeLine = styled.div`
  position: relative;
  flex: 0 0 18px;
  width: 18px;
  min-height: 88px;
  display: flex;
  justify-content: center;
  text-align: center;

  &:after {
    position: absolute;
    top: 18px;
    left: 50%;
    border-left: 2px dashed ${theme.colors.medium_gray};
    content: '';
    margin-left: -1px;
    height: calc(100% - 18px);
    z-index: 0;
  }
`;

export const DestinationTimes = styled(Row)`
  border-radius: 10px;
  padding: 0;
  height: 100%;
  margin: 0;
`;

export const DestinationWrap = styled(Row)`
  position: relative;
  margin: 0 0 16px;
  padding-left: 0;
  align-items: stretch;
  ${({ completed, progress }) =>
    `
        ${
          completed &&
          `
            ${Check} {
                background-color: ${theme.colors.success};
                > svg {
                    display: inline-block;
                }
            }
                
            ${TimeLine} {
                &:after {
                    border-color: ${theme.colors.success};
                }
            }
            ${DestinationTimes} {
                background-color: ${theme.colors.success_light};
            }
        `
        };

        ${
          progress &&
          `
            ${Check} {
                background-color: ${theme.colors.orange};
            }
            ${TimeLine} {
                &:after {
                    border-color: ${theme.colors.orange};
                }
            }
            ${DestinationTimes} {
                background-color: ${theme.colors.light_yellow};
            }
        `
        };
    `}
`;

export const InfoColumn = styled(Col)`
  padding: 8px 24px 8px 0;
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const InfoContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const TimeColumns = styled(Col)`
  padding-left: 0;
`;

export const TimeCell = styled(Col)`
  flex: 1;
  min-height: 96px;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  & + & {
    border-left: 1px dashed ${theme.colors.medium_gray};
  }
`;

export const WaitingCell = styled(Col)`
  width: 72px;
  min-width: 72px;
  padding: 20px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px dashed ${theme.colors.medium_gray};
`;

export const TimeInfo = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
`;

export const TravelLink = styled(Link)`
  > span {
    font-weight: 500 !important;
  }
`;
